import { CDN_BUCKET_URL } from '@/utils';

/**
 * País del build. Se lee directo de la variable y no de `@/config/country`
 * para no armar un ciclo de imports: `country.ts` importa las banderas desde
 * `@/assets`, que es este mismo barril.
 */
const COUNTRY = String(import.meta.env.VITE_COUNTRY ?? '').toLowerCase();

/**
 * Logo de la pantalla de login, por país.
 *
 * Perú usa el logo nuevo ("soyde — Más tiempo para ti"). Uruguay sigue con el
 * de siempre hasta que se decida cambiarlo: los dos paneles leen del mismo
 * bucket, así que pisar el archivo compartido cambiaría los dos a la vez.
 */
const LOGIN_LOGO_BY_COUNTRY: Record<string, string> = {
  pe: `${CDN_BUCKET_URL}/dashboard/icon_logo.png`,
};

export const images = {
  logo_primary: {
    src: LOGIN_LOGO_BY_COUNTRY[COUNTRY] ?? `${CDN_BUCKET_URL}/sd_logo_principal.png`,
    alt: 'Logo de la aplicación',
  },
  /**
   * Va en el header, que tiene fondo `--primary-color` (naranja). Por eso NO
   * se cambia por el logo nuevo: ese trae el "soyde" en naranja y el eslogan
   * en negro, y sobre la barra naranja la marca se pierde y el eslogan queda
   * ilegible. Esta versión está hecha para fondo de color.
   */
  logo_secondary: {
    src: `${CDN_BUCKET_URL}/sd_logo_secondary.svg`,
    alt: 'Logo de la aplicación',
  },
  isotype_primary: {
    src: `${CDN_BUCKET_URL}/sd_isotype_primary.svg`,
    alt: 'Isotipo de la aplicación',
  },
};
